import React, { useRef, useCallback } from "react";
import ReactQuill from "react-quill-new";
// @ts-ignore
import "react-quill-new/dist/quill.snow.css";
import styled from "styled-components";
import EditorToolbar, { modules, formats } from "./EditorToolbar";
import { CorporateTheme } from "../../../utils/themes";
import { useTheme } from "../../../middleware/ThemeContext";
interface StyledTextEditorProps {
  title?: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  isReadOnly?: boolean;
  minHeight?: string;
  isInvalid?: boolean;
  toolbarBg?: string;
  bodyBg?: string;
  borderColor?: string;
  fontFamily?: string;
}

const StyledTextEditor: React.FC<StyledTextEditorProps> = ({
  value,
  onChange,
  placeholder,
  minHeight,
  isInvalid = false,
  isReadOnly = false,
  toolbarBg,
  bodyBg,
  borderColor,
  fontFamily,
}) => {
const {theme} = useTheme();
  const quillRef = useRef<any>(null);

  const undoChange = useCallback(() => {
    if (!quillRef.current) {
      return;
    }

    const editor = quillRef.current.getEditor?.();
    if (!editor) {
      return;
    }

    const history = editor.getModule?.("history");
    if (history?.undo) {
      history.undo();
    }
  }, []);

  const redoChange = useCallback(() => {
    if (!quillRef.current) {
      return;
    }

    const editor = quillRef.current.getEditor?.();
    if (!editor) {
      return;
    }

    const history = editor.getModule?.("history");
    if (history?.redo) {
      history.redo();
    }
  }, []);
  // const modules = {
  //   toolbar: [
  //     ['bold', 'italic', 'underline'],
  //     [{ 'header': 1 }, { 'header': 2 }],
  //     [{ 'font': [] }],
  //     [{ 'size': [] }],
  //     [{ 'color': [] }, { 'background': [] }],
  //     [{ 'list': 'bullet' }, { 'list': 'ordered' }],
  //     [{ 'align': [] }],
  //     ['link', 'image', 'video'],
  //     ['clean', 'code-block'],
  //   ],
  // };

  return (
    <StyledTextEditorCss
      minHeight={minHeight}
      isInvalid={isInvalid}
      theme={theme}
      $toolbarBg={toolbarBg}
      $bodyBg={bodyBg}
      $borderColor={borderColor}
      $fontFamily={fontFamily}
    >
          <EditorToolbar onUndo={undoChange} onRedo={redoChange} />
      <ReactQuill
        ref={quillRef}
        value={value}
        onChange={onChange}
        modules={modules}
        placeholder={placeholder}
        readOnly={isReadOnly}
        theme="snow"
        className={`text-textColor fs-2  ${
          isReadOnly ? "cursor-not-allowed" : ""
        }`}
        // modules={modules}
        formats={formats}
      />
    </StyledTextEditorCss>
  );
};

export default StyledTextEditor;

const StyledTextEditorCss = styled.div<{
  theme?: string;
  isInvalid?: boolean;
  minHeight?: string;
  $toolbarBg?: string;
  $bodyBg?: string;
  $borderColor?: string;
  $fontFamily?: string;
}>`
  .ql-snow .ql-stroke.ql-fill {
    fill: ${({ theme }) =>
      theme.name === "dark" ? "#ffffff" : "#626262"} !important;
    stroke: ${({ theme }) =>
      theme.name === "dark" ? "#ffffff" : "#626262"} !important;
  }

  .ql-snow .ql-stroke {
    fill: none;
    stroke: ${({ theme }) =>
      theme.name === "dark" ? "#ffffff" : "#626262"} !important;
  }

  .ql-toolbar.ql-snow .ql-picker-label {
    color: ${({ theme }) =>
      theme.name === "dark" ? "#ffffff" : "#626262"} !important;
  }

  .ql-snow.ql-toolbar button:hover .ql-fill {
    fill: ${({ theme }) =>
      theme.name === "dark" ? "#1E1F21" : CorporateTheme?.colors?.textSecondary} !important;
  }

  .ql-snow.ql-toolbar button:hover .ql-stroke {
    stroke: ${({ theme }) =>
      theme.name === "dark" ? "#1E1F21" : CorporateTheme?.colors?.textSecondary} !important;
  }

  .ql-container {
    border: 0.5px solid
      ${({ theme, isInvalid, $borderColor }) =>
        $borderColor ? $borderColor : (isInvalid ? "#ef4444" : theme.name === "dark" ? "#575757" : "#C4D4E7")};
    border-radius: 0px 0px 3px 3px;
  }

  .ql-toolbar {
  display:flex;
  margin:0px;
    border: 0.5px solid
      ${({ theme, isInvalid, $borderColor }) =>
        $borderColor ? $borderColor : (isInvalid
          ? "#ef4444"
          : theme.name === "dark"
          ? "#575757"
          : "#C4D4E7")}!important;
    border-radius: 3px 3px 0px 0px;
    background-color: ${({ theme, $toolbarBg }) => 
      $toolbarBg ? $toolbarBg : (theme.name === "dark" ? "#626262" : "")};
  }

  .ql-editor {
    min-height: ${({ minHeight }) => (minHeight ? minHeight : "500px")};
    padding-top:5px;
    background-color: ${({ theme, $bodyBg }) => 
      $bodyBg ? $bodyBg : (theme.name === "dark" ? "#1E1F22" : "")};
    color: ${({ theme }) => theme.colors.contentText};
    font-family: ${({ $fontFamily }) => $fontFamily ? $fontFamily : '"Raleway", sans-serif'};

    &.ql-blank::before{
      color: #626262;
    }
  }
`;
  